import { computed } from 'vue'

export function useFooterConfig(config) {
  const footerPayload = computed(() => config ?? {})
  const customs = computed(() => footerPayload.value?.customs ?? {})
  const legacyFootConfig = computed(() => footerPayload.value?.legacy ?? {})

  const resourcesLinks = computed(() => {
    const resources = customs.value?.resources ?? []
    if (Array.isArray(resources) && resources.length) {
      return resources.filter((r) => r && r?.visible && r?.url && r?.label)
    }

    const leg = legacyFootConfig.value
    const links = []
    if (leg.learningCenter) links.push(leg.learningCenter)
    if (leg.tutorials) links.push(leg.tutorials)
    if (leg.knowledge) links.push(leg.knowledge)
    return links
  })

  const legalLinks = computed(() => {
    const leg = legacyFootConfig.value
    const links = []
    if (leg.terms) links.push(leg.terms)
    if (leg.privacy) links.push(leg.privacy)
    if (leg.trust_center) links.push(leg.trust_center)
    if (leg.guidelines) links.push(leg.guidelines)
    if (leg.legal) links.push(leg.legal)
    return links
  })

  const supportsLinks = computed(() => {
    const payload = footerPayload.value
    if (payload.isDefault) return []

    const supports = customs.value?.supports || []
    if (!Array.isArray(supports) || supports.length === 0) return []

    return supports
      .filter((s) => s && s?.visible)
      .map((s) => ({
        label: s.label ?? s.name,
        url: s.url ?? '#',
        id: s.id,
        openIn: s.openIn ?? '_blank'
      }))
  })

  const cookieConfig = computed(() => legacyFootConfig.value?.cookie ?? {})

  const copyrightText = computed(() => legacyFootConfig.value?.copyright?.label)
  const pricingLink = computed(() => legacyFootConfig.value?.pricing)
  const feedbackLabel = computed(() => legacyFootConfig.value?.feedback?.label)
  const contactLink = computed(() => legacyFootConfig.value?.contact)
  const doNotSellLabel = computed(() => cookieConfig.value.doNotSellLabel)
  const cookiePreferencesLabel = computed(() => cookieConfig.value.cookiePreferencesLabel)

  const showOneTrustLinks = computed(
    () =>
      !cookieConfig.value.hideOneTrustForLgWebOs &&
      Boolean(cookieConfig.value.enable_one_trust_on_footer)
  )

  const showTrustFlag = computed(() => Boolean(cookieConfig.value.showTrustFlag))

  return {
    resourcesLinks,
    legalLinks,
    showOneTrustLinks,
    showTrustFlag,
    supportsLinks,
    copyrightText,
    pricingLink,
    feedbackLabel,
    contactLink,
    doNotSellLabel,
    cookiePreferencesLabel
  }
}
